import { useState, useEffect } from 'react';
import { SovetService } from '../api/sovet';

export const useSovet = () => {
  const [sovet, setSovet] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSovet = async () => {
      try {
        const data = await SovetService.fetchSovet();
        setSovet(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSovet();
  }, []);

  return { sovet, loading, error };
};
